<template>
  <div
  :class="[
    'timetable_cell_card p-2 bg-white border rounded',
    `${cellData.type !== 0 ? ' border-danger': 'border-success'}`
  ]"
  >
      <!-- {{ cellData }} -->
      <div class="timetable_actions text-right">
        <a href="javascript:;" class="mr-2" @click="handleEditClick" v-if="rolesetting.editable">
          <i class="fe fe-edit text-dark"></i>
        </a>
        <a href="javascript:;" @click="handleDeleteClick" v-if="rolesetting.deletable">
          <i class="fe fe-trash text-danger"></i>
        </a>
      </div>
      <template v-if="cellData.type === 0">
        <div class="timetable_time text-primary">
          <small>{{ getTime(cellData) }}</small>
        </div>
         <div
    v-if="isTeacherMode && cellData.school_class && cellData.section"
    class="small text-primary font-weight-bold mb-1"
  >
    {{ cellData.school_class.name }} - {{ cellData.section.name }}
  </div>
        <template v-if="cellData && cellData.group_type !== 3">
          <div class="timetable_subject_name mt-1 mb-3">
            <p class="font-weight-bolder mb-0">
              {{ getSubjectName(cellData, 'abbreviation') }}
              <a v-if="cellData.meet_link" :href="cellData.meet_link" target="_blank" class="ml-2 text-primary" title="Join Google Meet">
                <i class="fe fe-video"></i>
              </a>
            </p>
          </div>
        </template>
        <template v-if="cellData && cellData.group_type === 3">
          <div class="timetable_subject_name mt-1 mb-3">
            <p class="mb-0">
              <strong
              v-for="(subject, index) in cellData.group_subject_entries"
              :key="subject.id"
              class="timetable_subject_name"
            >
              {{ subject.subject.abbreviation }}{{ index == cellData.group_subject_entries.length - 1 ? '' : ',' }}
            </strong>
            </p>
          </div>
        </template>
        <div class="timetable_teacher_name">
          <template v-if="cellData && cellData.group_type === 0">
            <p class="text-muted mb-0 mt-3">{{ getTeacher(cellData) }}</p>
          </template>
          <template v-if="cellData && cellData.group_type !== 0">
            <a-popover placement="bottom">
              <template slot="content">
                <table class="table table-sm table-striped mb-0">
                  <tbody>
                    <tr
                    v-for="subject in cellData.group_subject_entries"
                    :key="subject.id"
                    class="timetable_popover_tr"
                    >
                      <th scope="row">{{ subject.subject.abbreviation }}</th>
                      <td>{{ subject.teacher == null ? null : subject.teacher.first_name }} {{ subject.teacher == null ? null : subject.teacher.last_name }}</td>
                    </tr>
                  </tbody>
                </table>
              </template>
              <a-button type="link" class="p-0 m-0 text-muted">
                {{ groupName }} ({{ cellData.group_subject_entries.length }})
              </a-button>
            </a-popover>
          </template>
        </div>
      </template>

      <template v-else>
        <div class="timetable_time text-primary">
          <small>{{ getTime(cellData) }}</small>
        </div>

        <div class="timetable_break_container">
          <p class="mb-0 font-weight-bold text-danger">
            {{ cellData.type != 0 ? cellData.type_value : null}}
          </p>
        </div>
      </template>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'TimetableCell',
  props: {
    cellData: Object,
    rolesetting: { type: Object },
    isTeacherMode: { type: Boolean, default: false },

  },

  data: function() {
    return {
      timeFormat: 'h:mm a',
    }
  },
  computed: {
    groupName: function () {
      if (this.cellData.group_type === 1) {
        return 'Electives'
      }
      if (this.cellData.group_type === 2) {
        return 'Groups'
      }
      if (this.cellData.group_type === 3) {
        return 'Subjects'
      }
      return ''
    },
  },
  methods: {
    getSubjectName: function(data, key) {
      if (data) {
        switch (data.group_type) {
          case 1:
            return data.group_subject[key]
            // eslint-disable-next-line no-unreachable
            break
          case 2:
            return data.group_subject[key]
            // eslint-disable-next-line no-unreachable
            break
          default:
            return data.subject[key]
        }
      }
    },
    getTime(data) {
      if (data) {
        return moment(data.start_time, 'h:m:s').format(this.timeFormat) + ' - ' + moment(data.end_time, 'h:m:s').format(this.timeFormat)
      }
    },
    getTeacher(data) {
      console.log(data.group_type)
      if (data) {
        switch (data.group_type) {
          case 1:
            let name = ''
            data.group_subject_entries.forEach(element => {
              name = name + ' - ' + element.teacher.first_name
            })
            return name
            // eslint-disable-next-line no-unreachable
            break
          case 2:
            let name2 = ''
            data.group_subject_entries.forEach(element => {
              name2 = name2 + ' - ' + element.teacher.first_name
            })
            return name2
            // eslint-disable-next-line no-unreachable
            break
          default:
            return data.teacher == null ? null : data.teacher.first_name + ' ' + data.teacher.last_name
        }
      }
    },

    handleEditClick() {
      console.log('Edit clicked, isTeacherMode:', this.isTeacherMode)
      console.log('Cell data:', this.cellData)
      const data = this.cellData

      // Check if we're in teacher mode
      if (this.isTeacherMode) {
        // For teacher mode, open the teacher edit form
        this.$eventBus.$emit('openTeacherEditEntryModal', data)
        console.log('Emitted openTeacherEditEntryModal with data:', data)
      } else {
        // For class-section mode, open the regular edit form
        this.$eventBus.$emit('openTimetableEditEntryModal', data)
      }
    },
    handleDeleteClick() {
      const timetableId = this.cellData.id
      this.$confirm({
        title: 'Are you sure?',
        content: 'Click Yes to delete the timetable entry!',
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/timetable/' + timetableId)
            .then(() => {
              this.$emit('updateTable')
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Successfully Deleted!',
                description: 'Timetable entry has been deleted successfully!',
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
  },
}
</script>
<style lang="scss">
.timetable_cell_card {
  .timetable_actions {
    font-size: 0.85rem;
  }
  .timetable_subject_name {
    min-width: 80px;
    min-height: 1.85rem;
    height: 3rem;
    p {
      font-size: 0.9rem;
      line-height: 1rem;
    }
  }
  .timetable_teacher_name {
    p, .ant-btn {
      font-size: 0.85rem;
      line-height: 0.9rem;
    }
    .ant-btn {
      height: auto;
    }
  }
  .timetable_break_container{
    min-height: 4.5rem;
    min-width: 60px;
  }
}
tr.timetable_popover_tr {
  font-size: 0.85rem;
}
</style>
